import React, { useEffect, useMemo, useRef, useState } from 'react'
import SkeletonTicketList from '../../loaders/SkeletonTicketList';
import DataTable from 'react-data-table-component';
import { getAllAssessments } from '../../services/allAssessmentService';
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import AssignmentType from '../course/AssignmentType';
import AssignmentStatus from '../course/AssignmentStatus';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { TABLE_ROWS_PER_PAGE } from '../../utils/Constants';
import { twoDecimalRound } from '../../utils/commonFunction';
import { setIsAppeal } from '../../store/actions';

const typeOptions = [
    { id: 'action1', value: 'Assignment', icon: 'fa-file', color: 'blue' },
    { id: 'action2', value: 'Internal Exam', icon: 'fa-file', color: 'green' },
    { id: 'action3', value: 'External Exam', icon: 'fa-university', color: 'yellow' },
    { id: 'action4', value: 'Test', icon: 'fa-file', color: 'purple' },
    { id: 'action5', value: 'PoE-Formative', icon: 'fa-folder-tree', color: 'blue' },
    { id: 'action6', value: 'PoE-Summative', icon: 'fa-folder-tree', color: 'green' },
    { id: 'action7', value: 'PoE-Informal Activities', icon: 'fa-folder-tree', color: 'purple' },
    { id: 'action15', value: 'Survey', icon: 'fa-file', color: 'blue' },
    { id: 'action16', value: 'Sick Test', icon: 'fa-file', color: 'blue' },
    { id: 'action17', value: 'Supplementary Exam', icon: 'fa-file', color: 'blue' },
];

const statusOptions = [
    { id: "action8", value: "Closed Not-Submitted", label: "CLOSED NOT-SUBMITTED", color: "red" },
    { id: "action9", value: "Closed-Marked", label: "CLOSED-MARKED", color: "blue" },
    { id: "action10", value: "Closed-Submitted", label: "CLOSED-SUBMITTED", color: "yellow" },
    { id: "action11", value: "Submitted", label: "SUBMITTED", color: "green" },
    { id: "action12", value: "Pending", label: "PENDING", color: "yellow" },
    { id: "action13", value: "Draft", label: "DRAFT", color: "green" },
    { id: "action14", value: "Open", label: "OPEN", color: "blue" },
];


const MyAssessmentList = () => {
    const [loading, setLoading] = useState(false)
    const [allAssessmentList, setAllAssessmentList] = useState([]);
    const [status, setStatus] = useState([])
    const [search, setSearch] = useState("");
    const [selectedTypeIds, setSelectedTypeIds] = useState([]);
    const [selectedStatusIds, setSelectedStatusIds] = useState([]);

    const [expandedResultRows, setExpandedResultRows] = useState([]);
    const [expandedCourseRows, setExpandedCourseRows] = useState([]);

    const history = useHistory()
    const isWithHeldStatus = localStorage.getItem("resultWithHeld");
    const [showAppeal,setShowAppeal] = useState(false)
    const dispatch = useDispatch();

    const viewMe = (id, action, directLink) => {
        if (action == "view_appeal") {
            dispatch(setIsAppeal(true));
            // Set a flag to indicate we're coming from appeal
            sessionStorage.setItem('fromAppeal', 'true');
        } else {
            dispatch(setIsAppeal(false));
            sessionStorage.removeItem('fromAppeal');
        }

        if (!history.location.pathname.includes("shortCourse")) {
            // Pass additional data through navigation state
            history.push(directLink, {
                fromMyAssessment: true
            });
        }
    };
    const selectorState = useSelector((state) => state);
    const { user, isWithHeld } = selectorState

    const [overflowRows, setOverflowRows] = useState({});
    const [overflowCourseRows, setOverflowCourseRows] = useState({});
    const [resultSeeMore, setResultSeeMore] = useState([]);
    const contentRefs = useRef({});
    const courseRefs = useRef({})
    const [pageChangeTrigger, setPageChangeTrigger] = useState(0);
    // const isAssessmentDownloadBtn = useSelector(state => state.learningMaterial.isAssessmentDownloadBtn)
    const [tab,setTab] = useState('assessments')
    const [filteredAssignments, setFilteredAssignments] = useState([])

    useEffect(() => {dispatch(setIsAppeal(false))},[])

    const AppealButton = ({ appeal_button, row_id ,directLink }) => {
        switch (appeal_button) {
            case "appeal":
                return (
                    <>
                        <button
                            title="Appeal"
                            onClick={() => viewMe(row_id, "view_appeal",directLink)}
                            className="btn rounded-circle btn-danger appeal-icon-circle"
                        >
                            <i class="fal fa-book-reader"></i>
                            {/* <i className="fal fa-star"></i> Appeal */}
                        </button>
                    </>
                );
                break;
            case "appeal_view":
                return (
                    <>
                        <button
                            title="View Appeal"
                            onClick={() => viewMe(row_id, "view_appeal",directLink)}
                            className="btn rounded-circle btn-warning"
                        >
                            <i class="fal fa-book-reader"></i>
                            {/* <i className="fal fa-star"></i> View Appeal */}
                        </button>
                    </>
                );
                break;
            case "appeal_submit":
                return (
                    <>
                        <button
                            title="Appeal Submitted"
                            onClick={() => viewMe(row_id, "view_appeal",directLink)}
                            className="btn rounded-circle btn-gray"
                            disabled
                        >
                            <i class="fal fa-book-reader"></i>
                            {/* <i className="fa fa-star"></i> Appeal Submitted */}
                        </button>
                    </>
                );
                break;
            default:
                return (
                    <>
                        <button
                            title="No appeal options"
                            onClick={() => { }}
                            className="btn rounded-circle btn-gray"
                            disabled
                        >
                            <i class="fal fa-book-reader"></i>
                        </button>
                    </>
                );
                break;
        }
    };

    useEffect(() => {
        const newOverflowRows = {};

        // Use setTimeout to ensure DOM is fully rendered
        const timer = setTimeout(() => {
            Object.entries(courseRefs.current).forEach(([rowId, el]) => {
                if (!el) return;

                const lineHeight = parseFloat(getComputedStyle(el).lineHeight) || 20;
                const maxHeight = lineHeight * 2; // 2 lines

                if (el.scrollHeight > maxHeight + 1) {
                    newOverflowRows[String(rowId)] = true;
                }
            });
            setOverflowCourseRows(newOverflowRows);
        }, 100); // 100ms delay to ensure content is rendered

        return () => clearTimeout(timer);
    }, [allAssessmentList, pageChangeTrigger, search, selectedTypeIds, selectedStatusIds]);


    useEffect(() => {
        const newOverflowRows = {};

        setTimeout(() => {
            Object.entries(contentRefs.current).forEach(([rowId, el]) => {
                if (!el) return;

                const computed = window.getComputedStyle(el);
                const lineHeight = parseFloat(computed.lineHeight) || 16;
                const maxLines = 2;
                const maxAllowedHeight = lineHeight * maxLines;

                // Compare actual height vs maxHeight (2 lines)
                if (el.scrollHeight > maxAllowedHeight + 1) {
                    newOverflowRows[rowId] = true;
                }
            });

            setOverflowRows(newOverflowRows);
        }, 100);
    }, [allAssessmentList, pageChangeTrigger, search, selectedTypeIds, selectedStatusIds]);

    // Toggle expand/collapse
    const handleSeeMore = (row) => {
        const updated = [...resultSeeMore];
        const index = updated.indexOf(row.id);

        if (index > -1) {
            updated.splice(index, 1);
        } else {
            updated.push(row.id);
        }

        setResultSeeMore(updated);
    };

    const dataToRender = () => {
        let updatedData = []
        let allData = filteredAssignments
        if (search?.length) {
            let tempName = allData.filter(item => {
                const searchText = search.toLowerCase();
                // return item.studentCourses?.some(course =>
                   return item.name?.toLowerCase().includes(searchText)
                // );
            });


            let tempType = allData.filter(item => {
                let includes = item.ass_type && item.ass_type.toLowerCase().includes(search.toLowerCase())
                if (includes) {
                    return includes
                } else return null
            })
            let tempStatus = allData.filter(item => {
                let includes = item.status && item.status.toLowerCase().includes(search.toLowerCase())
                if (includes) {
                    return includes
                } else return null
            })
            let tempOpenDate = allData.filter(item => {
                let includes = item.open_date_time && (moment.unix(item.open_date_time).format("D MMM 'YY HH:mm a").toLowerCase().includes(search.toLowerCase()))
                if (includes) {
                    return includes
                } else return null
            })
            let tempCloseDate = allData.filter(item => {
                let includes = item.close_date_time && (moment.unix(item.close_date_time).format("D MMM 'YY HH:mm a").toLowerCase().includes(search.toLowerCase()))
                if (includes) {
                    return includes
                } else return null
            })

            let data = [...tempName, ...tempType, ...tempStatus, ...tempOpenDate, ...tempCloseDate]
            let unique = [...new Set(data)]
            updatedData = unique
        } else {
            updatedData = allData
        }

        if (selectedTypeIds.length) {
            let tempStatus = updatedData
            let tempSearch = tempStatus.filter(item => {
                let tempItem = item.ass_type ? item.ass_type.toLowerCase() : ''
                var tempItemNew = tempItem ? tempItem.replace(/-/g, ' ') : tempItem;
                const startsWith = selectedTypeIds.find(function (post, index) {
                    let tempPost = post ? post.toLowerCase() : ''
                    var tempPostNew = tempPost ? tempPost.replace(/-/g, ' ') : tempPost;
                    if (tempPostNew == tempItemNew)
                        return item;
                });
                if (startsWith) {
                    return startsWith
                } else return null
            })
            updatedData = tempSearch
        }

        if (selectedStatusIds.length) {
            let tempStatus = updatedData
            let tempSearch = tempStatus.filter(item => {
                let tempItem = item.status ? item.status.toLowerCase() : ''
                var tempItemNew = tempItem ? tempItem.replace(/-/g, ' ') : tempItem;
                const startsWith = selectedStatusIds.find(function (post, index) {
                    let tempPost = post ? post.toLowerCase() : post
                    var tempPostNew = tempPost ? tempPost.replace(/-/g, ' ') : tempPost;
                    if (tempPostNew == tempItemNew)
                        return item;
                });
                if (startsWith) {
                    return startsWith
                } else return null
            })
            updatedData = tempSearch
        }

        return updatedData
    }


    const toggleExpandCourses = (rowId) => {
        setExpandedCourseRows((prev) =>
            prev.includes(rowId)
                ? prev.filter((id) => id !== rowId)
                : [...prev, rowId]
        );
    };

    const toggleExpandResult = (id) => {
        setExpandedResultRows(prev =>
            prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
        );
    };

    const ShowResult = ({ data, isExpanded, onToggle }) => {
        const courses = data?.studentCourses || [];
        const displayedCourses = isExpanded ? courses : courses.slice(0, 3);

        if (data.grade === 1) {
            if (data.assessmentMarkPercentage === 0) {
                return (
                    <div className="assessment-07">
                        <div className="as-red-bg as-widget" title="Incomplete">
                            <p className="oneline-ellipsis">
                                <i className="fas fa-circle"></i> Incomplete
                            </p>
                        </div>
                    </div>
                );
            } else if (data.assessmentMarkPercentage > 49) {
                return (
                    <div className="assessment-07">
                        <div className="as-green-bg as-widget" title="Competent">
                            <p className="oneline-ellipsis">
                                <i className="fas fa-circle"></i> Competent
                            </p>
                        </div>
                    </div>
                );
            } else {
                return (
                    <div className="assessment-07">
                        <div className="as-orange-bg as-widget" title="Not Yet Competent">
                            <p className="oneline-ellipsis">
                                <i className="fas fa-circle"></i> Not Yet Competent
                            </p>
                        </div>
                    </div>
                );
            }
        } else if (data.grade === 3) {
            return (
                <div>
                    {displayedCourses.map((course, id) => {
                        const gradeText = course?.assCalculateGradeStatus?.gradeText ?? 0;
                        const totalMark = data?.subAssTotMark ?? 0;
                        return <div key={id}>{`${gradeText} / ${totalMark}`}</div>;
                    })}
                    {courses.length > 3 && (
                        <span onClick={onToggle} className="show-more-txt">
                            {isExpanded ? "See Less" : "See More"}
                        </span>
                    )}
                </div>
            );
        } else if (data.grade === 2) {
            return (
                <div>
                    {displayedCourses.map((course, id) => (
                        <div key={id}>{course?.assCalculateGradeStatus?.gradeText}</div>
                    ))}
                    {courses.length > 3 && (
                        <span onClick={onToggle} className="show-more-txt">
                            {isExpanded ? "See Less" : "See More"}
                        </span>
                    )}
                </div>
            );
        } else {
            return (
                <div>
                    {displayedCourses.map((course, id) => (
                        <div key={id}>
                            {`${twoDecimalRound(course?.assCalculateGradeStatus?.grade)}%`}
                        </div>
                    ))}
                    {courses.length > 3 && (
                        <span onClick={onToggle} className="show-more-txt">
                            {isExpanded ? "See Less" : "See More"}
                        </span>
                    )}
                </div>
            );
        }
    };





    const columns = useMemo(() => [
        {
            name: "Name",
            selector: "name",
            wrap: true,
            sortable: true,
            cell: (row) => (
                <div data-toggle="tooltip" title={row.name} className="assessment-02" 
                    // onClick={() => viewMe()}
                >
                   <Link to={`course/${row?.assignedCourses[0]?.intakeAssignedQualificaion?.qualification}/subject/${row?.assignedCourses[0]?.intake}/assessment/${row?.assessment_id}`}><p className='info-text plink'>{row?.name}</p></Link>
                </div>
            ),
        },
        {
            name: "Type",
            selector: "ass_type",
            sortable: true,
            cell: (row) => <AssignmentType ass_type={row.ass_type} />,
        },
        {
            name: "Linked Courses",
            selector: "related_course",
            cell: (row) => {
                const courses = row?.assignedCourses || [];
                const isExpanded = expandedCourseRows.includes(row.id);

                return (
                    <div>
                        <div
                            ref={(el) => (courseRefs.current[row.id] = el)}
                            style={{
                                maxHeight: isExpanded ? "none" : "3em", // 2 lines
                                overflow: "hidden",
                                lineHeight: "1.5em",
                            }}
                        >
                            {courses.map((course, id) => (
                                <Link key={id} to={`course/${course?.intakeAssignedQualificaion?.qualification}/subject/${course?.intake}`}>
                                    <p className='info-text plink' title={course?.courseName}>
                                        {course?.courseName}
                                    </p>
                                </Link>
                            ))}
                        </div>

                        {/* Button is OUTSIDE the overflow container */}
                        {overflowCourseRows[String(row.id)] && (
                            <span
                                className="table-see-more"
                                onClick={() => toggleExpandCourses(row.id)}
                                title={isExpanded ? "See Less" : "See More"}
                            >
                                See {isExpanded ? "Less" : "More"}...
                            </span>
                        )}
                    </div>
                );
            },
        },
        {
            name: "Status",
            sortable: true,
            selector: "status",
            cell: (row) => <AssignmentStatus status={row.status} />,

        },
        {
            name: <div className="thead-conditions">Conditions <i data-toggle="tooltip" title="This communicates the nature of an exam/assessment and the conditions associated with it" className="fal fa-info-circle"></i></div>,
            selector: "conditions",
            minWidth: "180px",
            cell: (row) => (
                <div className="table-exam-act">
                    <span className="ts-info-act">
                        {row.camera ? <i data-toggle="tooltip" title="This exam requires your computer/Laptop to have an operational webcam" className="fal fa-webcam active"></i> : null}
                        {row.audio ? <i data-toggle="tooltip" title="This exam requires your computer/Laptop to have an operational microphone" className="fal fa-microphone"></i> : null}
                        {row.screen_share ? <i data-toggle="tooltip" title="This exam will record the contents of your screen, please have one screen and disconnect secondary screens" className="fal fa-desktop"></i> : null}
                        {row.timeLimitActive ? <i data-toggle="tooltip" title="This is a timed exam" className="fal fa-clock"></i> : null}
                        {/* <button type="button" className="btn btn-secondary" data-toggle="tooltip" data-placement="right" title={(row.camera || row.audio || row.screen_share) ? "This assignment has conditions" : "This exam will have no conditions"}><i className="fal fa-info-circle"></i></button> */}
                    </span>
                </div>
            ),
            // button: true,
        },
        {
            name: "Open Date",
            selector: "open_date_time",
            sortable: true,
            cell: (row) => (
                <div className="assessment-04 dateTime">
                    <p className="right-space">{moment.unix(row.open_date_time).format("D MMM 'YYYY")}</p><p>{moment.unix(row.open_date_time).format("HH:mm")}</p>
                    {/* <p className="right-space">{row?.formatted_open_date_time ? row?.formatted_open_date_time : "-"}</p> */}
                </div>
            ),
        },
        {
            name: "Close Date",
            sortable: true,
            selector: "close_date_time",
            wrap: true,
            cell: (row) => (
                <div className="assessment-05 dateTime">
                    <p className="right-space">{moment.unix(row.close_date_time).format("DD MMM 'YYYY")}</p><p>{moment.unix(row.close_date_time).format("HH:mm")}</p>
                    {/* <p className="right-space">{row?.formatted_close_date_time ? row?.formatted_close_date_time : "-"}</p> */}
                </div>
            ),
        },
        {
            name: "Duration",
            selector: "timeHour",
            sortable: true,
            cell: (row) =>
                row.timeLimitActive == 1 ? <div class="assessment-06"><p>{row?.timeHour}h:{row?.timeMin}m</p></div> : "N/A",
        },
        {
            name: "Results",
            selector: "grade",
            sortable: false,
            minWidth: "120px",
            cell: (row) => {
                // Only show results if conditions are met
                return (row.ass_type != "Survey" ?
                    (row.status === "Closed-Submitted" ? "-" : (row.status == "Closed-Marked" || row.status == "Closed Not-Submitted") && user.status != "Results Witheld" && isWithHeldStatus != "true" && row.notify_assessed == 1 ? <>
                    <div className='d-flex flex-column gap-1'>
                        <div
                            ref={(el) => (contentRefs.current[row.id] = el)}
                            style={{
                                maxHeight: resultSeeMore.includes(row.id) ? "none" : "3em",
                                overflow: "hidden",
                                whiteSpace: "normal",
                                lineHeight: "1.5em",
                            }}

                        >
                            {(row?.assignedCourses || []).filter((d,i) => row?.studentCourses?.find(data => data.intake == d.intake)?.grading_type != "4").map((item, index) => (
                                <div key={index}>
                                    <span>{item?.courseName}&nbsp;:&nbsp;</span>
                                    <strong>
                                        {(row?.studentCourses?.find(d => d.intake == item.id))?.grading_type == 3
                                            ? `${parseFloat(parseFloat(row?.studentCourses?.find(d => d.intake == item.id)?.gradeText)?.toFixed(2))}/${(row?.studentCourses?.find(d => d.intake == item.id))?.ass_total_mark}`
                                            : (row?.studentCourses?.find(d => d.intake == item.id))?.gradeText}
                                    </strong>
                                </div>
                            ))}
                        </div>

                        {overflowRows[row.id] && (
                            <span
                                className="table-see-more"
                                onClick={() => handleSeeMore(row)}
                                title={resultSeeMore.includes(row.id) ? "See Less" : "See More"}
                            >
                                See {resultSeeMore.includes(row.id) ? "Less" : "More"}...
                            </span>
                        )}
                    </div>
                    </> : user.status == "Results Witheld" && isWithHeldStatus == "true" ? <span className="witheld-status">WITHHELD</span> : "-")
                    : "-")
            }
        },
        {
            name: "Action",
            // minWidth: "120px",
            cell: (row) => (
                <div class="assessment-08 d-flex">
                    <div class="as-buttons">
                        <button
                            title="Open"
                            class="btn btn-primary rounded-circle"
                            onClick={() => history.push(`course/${row?.assignedCourses[0]?.intakeAssignedQualificaion?.qualification}/subject/${row?.assignedCourses[0]?.intake}/assessment/${row?.assessment_id}`)}
                        >
                            <i class="fal fa-folder-open"></i>
                        </button>
                    </div>
                    <div class="as-buttons">
                        <AppealButton appeal_button={row.appeal_button} row_id={row.id} directLink={`course/${row?.assignedCourses[0]?.intakeAssignedQualificaion?.qualification}/subject/${row?.assignedCourses[0]?.intake}/assessment/${row?.assessment_id}`}/>
                    </div>

                </div>
            ),
            // button: true,
        },
    ]);


    const handleStatusFilter = (e) => {
        const { value, checked } = e.target;
        setSelectedStatusIds((prev) =>
            checked ? [...prev, value] : prev.filter((item) => item !== value)
        );
    };


    // ** Function to handle type filter  
    const handleTypeFilter = e => {
        const { value, checked } = e.target;
        setSelectedTypeIds((prev) =>
            checked ? [...prev, value] : prev.filter((item) => item !== value)
        );
    };


    const resetFilter = () => {
        setSearch("")
        setSelectedStatusIds([])
        setSelectedTypeIds([])
    };


    const fetchAllAssessment = async () => {
        try {
            setLoading(true)
            const res = await getAllAssessments()
            const finalData = res?.data.map((item,index) => {
            if (item.status == "Closed-Marked" && item.notify_assessed == 0) {
              item.status = "Closed-Submitted";
            }
            return item;
          })
            setAllAssessmentList(finalData)
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchAllAssessment()
    }, [])

     useEffect(() => {
        const todayStart = moment().startOf("day"); // Start of today (midnight)
        const todayEnd = moment().endOf("day"); // End of today (11:59:59 PM)
      
        let filteredAssignments;
    
        switch (tab) {
          case "upcoming":
            filteredAssignments = allAssessmentList.filter(
              (item) =>
                item.status !== "Closed Not-Submitted" && // Exclude "Closed Not-Submitted" items
                moment(item.close_date_time * 1000).isSameOrAfter(moment().startOf('day')) // Compare close time with the start of today
            );
            break;
    
          case "past":
            filteredAssignments = allAssessmentList.filter(
              (item) =>
                item.status === "Closed Not-Submitted" && // Include only "Closed Not-Submitted" items
              moment(item.close_date_time * 1000).isBefore(moment())// Compare close time with the start of today
            );
            break;
    
          case "marked":
            filteredAssignments = allAssessmentList.filter(
              (item) => item.notify_assessed === 1
            );
            break;
    
          default:
            filteredAssignments = allAssessmentList; // Default to showing all assignments
            break;
        }
      
        setFilteredAssignments(filteredAssignments);
      }, [tab,allAssessmentList]);


    return (
        <div className='custom-table-div custom-table-div2 filter-search-icon card card-table-custom'>
            <div className="top-bar-head-sec assessment__container__main">

            <div className="d-flex align-items-center assessment__head__container">
            <div className="assessment-table-heading">
              Assessments
            </div>
            <div className="lecture-tabs-wrap assessment__tab__container">
              <ul className="nav nav-pills course-nav-sticky assessment__filter__tabs" id="pills-tab" role="tablist" style={{ border: "none", marginLeft: "25px" }}>
                <li className="nav-item " title="Overview" onClick={() => setTab("upcoming")}>
                  <span className={`nav-link assessment-tab-item ${tab == "upcoming" ? "active" : ""}`}>
                    <i className="fal fa-calendar-days"></i>
                    Upcoming
                  </span>
                </li>

                <li className="nav-item" title="Overview" onClick={() => setTab("past")}>
                  <span className={`nav-link assessment-tab-item ${tab == "past" ? "active" : ""}`}>
                    <i className="fal fa-history"></i>
                    Past
                  </span>
                </li>

                <li className="nav-item" title="Overview" onClick={() => setTab("marked")}>
                  <span className={`nav-link assessment-tab-item ${tab == "marked" ? "active" : ""}`}>
                    <i className="fal fa-clipboard-check"></i>
                    Marked
                  </span>
                </li>

                <li className="nav-item" title="Overview" onClick={() => setTab("assessments")}>
                  <span className={`nav-link assessment-tab-item ${tab == "assessments" ? "active" : ""}`}>
                    <i className="fal fa-ballot-check"></i>
                    All Assessments
                  </span>
                </li>
              </ul>
            </div>
           {/* {isAssessmentDownloadBtn ?<div className="download__assesment__section">
            <button
              title="Download All"
              className={`btn btn-white-bordered download-assess`}
              onClick={() => {}}
              // data-toggle="modal"
              // data-target="#downloadAssessmentAll"
              >
              <i className="fal fa-arrow-to-bottom"></i>Download All
            </button>
          </div>: null}  */}
          </div>
            <div className="data-table-extensions assessment__filter__container p-0" style={{ gap: "50px" }}>
                <div className="data-table-extensions-filter" style={{ top: "auto", display: "flex", }}>
                    <label htmlFor="filterDataTable" className="icon"></label>
                    <input
                        type="text"
                        name="filterDataTable"
                        className="filter-text"
                        placeholder="Search"
                        onChange={(e) => setSearch(e.target.value)}
                        value={search}
                    />
                    <div className="filter-eff filter-data-btn">
                        <button className="filter-buttons">
                            <i className="fal fa-filter"></i>
                        </button>
                    </div>
                </div>
                <div className="filter-button-group assessment__filter__group m-0 ">
                    <div className="assessment-table-filter filter__assessments">
                        <div className="btn-type-filter dropdown-comman">
                            <div className="dropdown multiselect">
                                <button
                                    className={`btn btn-default dropdown-toggle ${selectedTypeIds.length > 0 ? 'btn-selected' : ''}`}
                                    type="button"
                                    id="typeBtnId"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="true"
                                    data-bs-toggle="dropdown"
                                    data-bs-auto-close="false"
                                    title="Type"
                                >
                                    <span>
                                        Type <i className="fal fa-angle-down"></i>
                                    </span>
                                </button>
                                <form className="dropdown-menu remove-list-style">
                                    <ul aria-labelledby="typeBtnId">
                                        {typeOptions.map(({ id, value, icon, color }) => (
                                            <li key={id} className={`item-text-${color}`}>
                                                <input
                                                    type="checkbox"
                                                    id={id}
                                                    value={value}
                                                    onClick={handleTypeFilter}
                                                    checked={selectedTypeIds?.includes(value)}
                                                />
                                                <label htmlFor={id}>
                                                    <i className={`fal ${icon}`}></i> {value}
                                                </label>
                                            </li>
                                        ))}
                                    </ul>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="assessment-table-status">
                        <div className="btn-type-Status dropdown-comman">
                            <div className="dropdown multiselect">
                                <button
                                    className={`btn btn-default dropdown-toggle ${selectedStatusIds?.length > 0 ? 'btn-selected' : ''}`}
                                    type="button"
                                    id="dropdownMenu1"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="true"
                                    title="Status"
                                >
                                    <span>
                                        Status <i className="fal fa-angle-down"></i>
                                    </span>
                                </button>
                                <form className="dropdown-menu remove-list-style">
                                    <ul aria-labelledby="dropdownMenu1">
                                        {statusOptions.map(({ id, value, label, color }) => (
                                            <li key={id} className={`item-text-${color}`}>
                                                <input
                                                    type="checkbox"
                                                    id={id}
                                                    value={value}
                                                    onChange={handleStatusFilter}
                                                    checked={selectedStatusIds.includes(value)}
                                                />
                                                <label htmlFor={id}>
                                                    <span className={`as-${color}-bg as-widget`}>{label}</span>
                                                </label>
                                            </li>
                                        ))}
                                    </ul>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="button-reset">
                        <button className="btn btn-primary" onClick={resetFilter} title="Reset">
                            <i className="fal fa-redo"></i>Reset
                        </button>
                    </div>
                </div>
            </div>

            {loading
                ? <SkeletonTicketList />
                : <DataTable
                    title="Assessments"
                    columns={columns}
                    data={dataToRender()}
                    pagination={true}
                    defaultSortField="close_date_time"
                    defaultSortAsc={false}
                    onChangePage={() => setPageChangeTrigger((prev) => prev + 1)}
                />
            }
            </div>

        </div>
    )
}

export default MyAssessmentList